import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des agences.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyList = (token) => {
    const url = `/api-v1/agency/list`
    return getRequest(url, token)
};

/**
 * Récupération des infos relatives aux relations de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyRelationInfos = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/relation`
    return getRequest(url, token)
};

/**
 * Récupération des infos de contact de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @param int $agencyId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyContactInfos = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/contact`
    return getRequest(url, token)
};

/**
 * Récupération des infos générales de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @param int $agencyId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyMainInfos = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/infos`
    return getRequest(url, token)
};

/**
 * Récupération des infos du responsable de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @param int $agencyId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyManager = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/manager`
    return getRequest(url, token)
};

/**
 * Récupération des infos du site de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @param int $agencyId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencySiteInfos = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/website`
    return getRequest(url, token)
};

/**
 * Récupération des infos de facturation de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @param int $agencyId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyBillingInfos = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/billing`
    return getRequest(url, token)
};

/**
 * Modification des infos de facturation de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 */
export const updateAgencyBillingInfos = (token, body) => {
    const url = `/api-v1/admin/agency/billing/update`
    return postRequest(url, body, token)
}

/**
 * Récupération de la liste des agences de facturation.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getBillingAgencyList = (token) => {
    const url = `/api-v1/admin/billing/agency/list`
    return getRequest(url, token)
};

/**
 * Post de l'action sur le changement de visibilité d'une agence.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const setAgencyEnabled = (token, agencyId) => {
    const url = `/api-v1/admin/agency/enable`
    return postRequest(url, agencyId, token)
};

/**
 * Enregistrement des modifications pour une agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateAgencyInfos = (token, body) => {
    const url = `/api-v1/admin/agency/main/infos`
    return postRequest(url, body, token)
};

/**
 * Enregistrement des modifications du site d'une agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateAgencySisInfos = (token, body) => {
    const url = `/api-v1/admin/agency/website`
    return postRequest(url, body, token)
};

/**
 * Vérification du caractère unique de l'url du site d'une agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const checkAgencyUniqueUrl = (token, body) => {
    const url = `/api-v1/admin/agency/check/unique/url`
    return postRequest(url, body, token)
};

/**
 * Enregistrement des modifications des relations d'une agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateRelationInfos = (token, body) => {
    const url = `/api-v1/admin/agency/relation`
    return postRequest(url, body, token)
};

/**
 * Enregistrement des modifications des contacts d'une agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateAgencyContact = (token, body) => {
    const url = `/api-v1/admin/agency/contact`
    return postRequest(url, body, token)
};

/**
 * Création d'une nouvelle agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const createAdminAgency = (token, body) => {
    const url = `/api-v1/admin/agency/new`
    return postRequest(url, body, token)
};

/**
 * Suppression d'une agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const deleteAgencyFromDB = (token, body) => {
    const url = `/api-v1/admin/agency/delete`
    return postRequest(url, body, token)
};

/**
 * Mise à jour des images d'une agence.
 *
 * @param token Jeton d'authentification.
 * @param body Body de la requête.
 * @param id Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const uploadFile = (token, body, id) => {
    const url = `/api-v1/admin/agency/${id}/upload/file`
    return postRequest(url, body, token)
};

/**
 * Lecture des informations d'une agence côté pro.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyProInfos = (token, id) => {
    const url = `/api-v1/agency/${id}/infos`
    return getRequest(url, token)
};

/**
 * Récupération des infos de contact de l'agence côté pro.
 *
 * @param string $token Jeton d'authentification.
 * @param int $agencyId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyContactProInfos = (token, agencyId) => {
    const url = `/api-v1/agency/${agencyId}/contact`
    return getRequest(url, token)
};

/**
 * Lecture de la liste des agences côté admin.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAdminAgencyList = async (token, pageNumber, itemsPerPage, keywords) => {
    const url = `/api-v1/admin/agency/${pageNumber}/${itemsPerPage}/${keywords}/list`
    return await getRequest(url, token);
};